
import { useStore } from 'vuex'
import { computed, reactive } from 'vue';

export default {
	emits: ['hide'],
	name: 'DialogRewardRules',
	props: [""],
	setup(props, { emit }) {
		const store = useStore()
		const local = computed(() => store.state.translation.locale)
		const data = reactive({
		})

		const hide_ = () => {
			emit('hide')
		}

		return {
			local,
			props,
			data,
			hide_,
		}
	}
}
